/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import {
  Checkbox, Loader, Label, Message, Modal
} from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import Update from 'immutability-helper';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import progress from '../../images/icons/progress_ica.gif';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import WithRouter from '../Extensions/WithRouter';

class UpdateSystem extends Component {
  constructor(props) {
    super(props);
    this.updateInterval = null;
    this.showLogInterval = null;
    this.isRunUpdate = false;
    this.isStopUpdate = false;
    this.state = {
      isPageLoading: false,
      checkValue: [],
      ///errorCode: null,
      errorMsg: null,
      latestUpdates: {},
      updateSetting: {
        mode: '',
        interval: '',
        schedule: [],
      },
      updateProxy: {
        proxy_mode: 'never',
        proxy_url: '',
      },
      updateSetClone: [],
      updateStatus: '',
      updateLogs: [],
      isLoading: true,
      isUpdateError: false,
      isVisibleLog: false,
      isLoadingBtn: false,
      isProxyError: false,
      isLoadingProxyElement: false,
      isLoadingProxyBtn: false,
      proxyErrorMsg: '',
      modalAlert: false,
      modalAlertTitle: '',
      modalAlertMsg: '',
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.setProxyConfig = this.setProxyConfig.bind(this);
    this.handleUpdateToggle = this.handleUpdateToggle.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleStyleChange = this.handleStyleChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleMinChange = this.handleMinChange.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleLogToggle = this.handleLogToggle.bind(this);
    this.handleProxyChange = this.handleProxyChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    if (this.state.updateStatus !== prevState.updateStatus && this.state.updateStatus === 'updating' && !this.isRunUpdate) {
      this.onUpdateWithLogStart();
      this.isRunUpdate = true;
      this.isStopUpdate = false;
    }
    if (this.state.updateStatus !== prevState.updateStatus && this.state.updateStatus === 'idle' && !this.isStopUpdate) {
      this.onUpdateWithLogStop();
      this.isStopUpdate = true;
      this.isRunUpdate = false;
    }

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getUpdateInfo();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.updateInterval) {
      this.onUpdateStop();
    }
    if (this.showLogInterval) {
      this.onUpdateWithLogStop();
    }
  }

  handleCloseAlert() {
    this.setState({
      modalAlert: false,
    });
  }

  handleProxyChange = (value) => {
    const { updateProxy, isProxyError, isLoadingProxyBtn } = this.state;
    if (isLoadingProxyBtn) {
      return;
    }
    if (updateProxy.proxy_mode === value) {
      if (isProxyError) {
        this.setState({
          isProxyError: false,
          proxyErrorMsg: '',
        });
      }
      return;
    }

    this.setState({
      updateProxy: Update(updateProxy, {
        proxy_mode: {
          $set: value,
        },
      }),
      isProxyError: false,
      proxyErrorMsg: '',
    }, () => {
      this.getProxyUrl(value);
    });
  };

  handleInputChange(e) {
    const { updateProxy } = this.state;

    this.setState({
      updateProxy: Update(updateProxy, {
        proxy_url: {
          $set: e.target.value,
        },
      }),
      isProxyError: false,
      proxyErrorMsg: '',
    });
  }

  handleStyleChange = (e) => {
    const target = e.target.text;
    const { t } = this.props;
    const { updateSetting, updateSetClone } = this.state;
    let newArr;

    let smallLetterFirstLetter = `${target.charAt(0).toLowerCase()}${target.slice(1)}`;

    if (smallLetterFirstLetter === 'scheduled') {
      smallLetterFirstLetter = 'schedule';
    }
    if (updateSetting.mode === smallLetterFirstLetter) {
      return;
    }

    if (updateSetClone.mode === 'schedule') {
      newArr = updateSetClone.schedule.map((item) => {
        return item.day_of_week;
      });
    }

    if (target === t('system.list.scheduled')) {
      smallLetterFirstLetter = 'schedule';
    }

    if (target === t('system.list.never')) {
      smallLetterFirstLetter = 'never';
    }

    if (target === t('system.list.interval')) {
      smallLetterFirstLetter = 'interval';
    }

    this.setState({
      updateSetting: Update(updateSetting, {
        mode: {
          $set: smallLetterFirstLetter,
        },
        interval: {
          $set: updateSetClone.interval === 0 ? '' : updateSetClone.interval,
        },
        schedule: {
          $set: updateSetClone.schedule,
        },
      }),
      checkValue: updateSetClone.schedule.length === 0 ? [] : newArr,
    });
  };

  handleCheckChange(e, { value }) {
    const { checkValue, updateSetting } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
      const newSetting = updateSetting.schedule.filter((item) => {
        return item.day_of_week !== value;
      });
      this.setState({
        updateSetting: Update(updateSetting, {
          schedule: {
            $set: newSetting,
          },
        }),
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleTimeChange = (e) => {
    const { updateSetting } = this.state;
    if (updateSetting.mode === 'interval') {
      if (Number(e.target.value) > 168 || Number(e.target.value) <= 0) {
        return null;
      }
      this.setState({
        updateSetting: Update(updateSetting, {
          interval: {
            $set: e.target.value,
          },
        }),
      });
      return;
    }

    /** check for add or update */
    if (updateSetting.schedule.length !== 0) {
      const updateIndex = updateSetting.schedule.findIndex((item) => {
        return item.day_of_week === e.currentTarget.dataset.id;
      });

      if (updateIndex !== -1) {
        this.setState({
          updateSetting: Update(updateSetting, {
            schedule: {
              [updateIndex]: {
                hour: {
                  $set: e.target.value,
                },
              },
            },
          }),
        });
      } else {
        this.setState({
          updateSetting: Update(updateSetting, {
            schedule: {
              $push: [
                {
                  day_of_week: e.currentTarget.dataset.id,
                  hour: e.target.value,
                },
              ],
            },
          }),
        });
      }
    } else {
      this.setState({
        updateSetting: Update(updateSetting, {
          schedule: {
            $push: [
              {
                day_of_week: e.currentTarget.dataset.id,
                hour: e.target.value,
              },
            ],
          },
        }),
      });
    }
  };

  handleMinChange = (e) => {
    const { updateSetting } = this.state;
    const updateIndex = updateSetting.schedule.findIndex((item) => {
      return item.day_of_week === e.currentTarget.dataset.id;
    });

    this.setState({
      updateSetting: Update(updateSetting, {
        schedule: {
          [updateIndex]: {
            minute: {
              $set: e.target.value,
            },
          },
        },
      }),
    });
  };

  handleUpdateToggle = () => {
    const { updateStatus } = this.state;
    //isLoadingBtn
    if (updateStatus === 'idle') {
      this.setState(
        {
          isLoadingBtn: true,
        },
        () => {
          this.runUpdate();
        }
      );
    } else {
      this.setState(
        {
          isLoadingBtn: true,
        },
        () => {
          this.stopUpdate();
        }
      );
    }
  };

  handleLogToggle = () => {
    const { isVisibleLog } = this.state;
    if (isVisibleLog) {
      this.setState({
        isLoadingChk: false,
        isVisibleLog: false,
      });
    } else {
      this.setState({
        isLoadingChk: true,
        isVisibleLog: true,
      }, () => {
        this.showUpdateLog();
      });
    }
  };

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onUpdateStart() {
    this.updateInterval = null;
    if (!this.onUpdateRunning()) { //update 진행중 아님
      this.updateInterval = setInterval(() => {
        this.getOnlyUpdateStatus();
      }, 6500);
    }
  }

  onUpdateStop() {
    clearInterval(this.updateInterval);
    this.updateInterval = null;
  }

  onUpdateRunning() {
    return this.updateInterval !== null;
  }

  onUpdateWithLogStart() {
    this.showLogInterval = null;
    if (!this.onUpdateRunning()) { //update 진행중 아님
      this.showLogInterval = setInterval(() => {
        this.showUpdateLog();
      }, 5000);
    }
  }

  onUpdateWithLogStop() {
    clearInterval(this.showLogInterval);
    this.showLogInterval = null;
  }

  /*
  onUpdateWithLogRunning() {
    return this.showLogInterval !== null;
  }
*/
  onSubmit() {
    const { updateSetting, checkValue } = this.state;
    const { t } = this.props;
    const newData = {
      mode: updateSetting.mode,
      interval: updateSetting.mode === 'interval' ? updateSetting.interval : '',
      schedule: updateSetting.mode === 'schedule' ? updateSetting.schedule : [],
    };

    if (updateSetting.mode === 'interval' && !updateSetting.interval) {
      this.setState({
        modalAlert: true,
        modalAlertTitle: t('modal.title.attention'),
        modalAlertMsg: t('system.message.update_interval'),
      });
      return null;
    }
    if (updateSetting.mode === 'schedule') {
      if (updateSetting.schedule.length === 0) {
        this.setState({
          modalAlert: true,
          modalAlertTitle: t('modal.title.attention'),
          modalAlertMsg: t('system.message.select_one_schedule'),
        });
        return null;
      }
      if (updateSetting.schedule.length !== checkValue.length) {
        this.setState({
          modalAlert: true,
          modalAlertTitle: t('modal.title.attention'),
          modalAlertMsg: t('system.message.select_hours'),
        });
        return null;
      }
      if (updateSetting.schedule.length !== 0) {
        const checkArray = updateSetting.schedule.filter((item) => {
          return item.minute === undefined;
        });
        if (checkArray.length !== 0) {
          this.setState({
            modalAlert: true,
            modalAlertTitle: t('modal.title.attention'),
            modalAlertMsg: t('system.message.select_minutes'),
          });
          return null;
        }
      }
    }
    this.setUpdateConfig(newData);
  }

  getUpdateInfo() {
    const { t, navigate } = this.props;
    api
      .getUpdateInfo()
      .then((response) => {
        let newArr;
        const data = convertPropertiesToCamelCase(response.response);
        if (data.updateSetting.mode === 'schedule') {
          newArr = data.updateSetting.schedule.map((item) => {
            return item.day_of_week;
          });
        }
        this.setState(
          {
            isLoading: false,
            latestUpdates: data.latestUpdates,
            updateSetting: data.updateSetting,
            updateStatus: data.updateStatus,
            updateProxy: data.updateProxy,
            checkValue: newArr || [],
            updateSetClone: data.updateSetting,
          },
          () => {
            setTimeout(() => {
              this.onUpdateStart(); //update check
            }, 1000);
          }
        );
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-652') {
          this.setState({
            isUpdateError: true,
            isLoading: false,
            //errorCode: o.error,
            errorMsg: t('system.message.not_installed_update'),
          });
        } else if (o.error === '403-366') { //403-002
          this.setState({
            isUpdateError: true,
            isLoading: false,
            //errorCode: o.error,
            errorMsg: t('system.message.license_expired'),
          }, () => {
            window.setTimeout(() => {
              navigate('/systems/license');
            }, 1500);
          });
        } else if (o.error === '403-001') {
          this.setState({
            isUpdateError: true,
            isLoading: false,
            //errorCode: o.error,
            errorMsg: t('system.message.not_registerd_company'),
          }, () => {
            window.setTimeout(() => {
              navigate('/systems/license');
            }, 1500);
          });
        } else if (o.error === '422-651') {
          window.setTimeout(() => {
            navigate('/systems/license');
          }, 1500);
        } else {
          this.setState({
            isLoading: false,
            isUpdateError: true,
            errorMsg: t('modal.error.unknow_error'),
          });
        }
      });
  }

  getUpdateStatus() {
    const { updateStatus, latestUpdates } = this.state;
    const { t } = this.props;
    api
      .getUpdateStatus()
      .then((response) => {
        const data = convertPropertiesToCamelCase(response.response);

        if (updateStatus !== data.updateStatus) {
          this.setState({
            updateStatus: data.updateStatus,
          });
        }

        this.setState({
          latestUpdates: Update(latestUpdates, {
            clarity: {
              status: {
                $set: data.latestUpdates.clarity.status,
              },
              version: {
                $set: data.latestUpdates.clarity.version,
              },
            },
            oss_db: {
              status: {
                $set: data.latestUpdates.oss_db.status,
              },
              version: {
                $set: data.latestUpdates.oss_db.version,
              },
            },
            security_db: {
              status: {
                $set: data.latestUpdates.security_db.status,
              },
              version: {
                $set: data.latestUpdates.security_db.version,
              },
            },
          }),
          //errorCode: null,
          errorMsg: null,
        });
        setTimeout(() => {
          this.onUpdateStart(); //update check
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        //const o = err.data.response;
        this.setState({
          isUpdateError: true,
          //errorCode: o.error || null,
          errorMsg: t('system.message.waiting_server_response'),
        });
      });
  }

  getOnlyUpdateStatus(callback) {
    const { updateStatus } = this.state;
    const { t } = this.props;
    api
      .getOnlyUpdateStatus()
      .then((response) => {
        const data = convertPropertiesToCamelCase(response.response);
        if (updateStatus !== data.updateStatus && !callback) {
          this.onUpdateStop();
          this.getUpdateStatus();
        }

        if (callback && data.updateStatus === 'updating') {
          this.setState(
            {
              updateStatus: data.updateStatus,
              isLoadingBtn: false,
            },
            () => {
              this.showUpdateLog();
            }
          );
        } else {
          this.setState({
            updateStatus: data.updateStatus,
            isLoadingBtn: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        //const o = err.data.response;

        this.setState({
          isUpdateError: true,
          //errorCode: o.error || null,
          errorMsg: t('system.message.waiting_server_response'),
        });
      });
  }

  getProxyUrl(value) {
    const { updateProxy } = this.state;
    const data = {
      proxy_mode: value,
    };
    this.setState({
      isLoadingProxyBtn: true,
    }, () => {
      api
        .getProxyUrl(data)
        .then((response) => {
          const res = response.response;
          this.setState({
            isLoadingProxyBtn: false,
            updateProxy: Update(updateProxy, {
              proxy_url: {
                $set: res.proxy_url,
              },
            }),
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          if (o.error === '422-366') {
            this.setState({
              isProxyError: true,
              isLoadingProxyBtn: false,
              proxyErrorMsg: o.error_description,
            });
          }
        });
    });
  }

  setUpdateConfig(data) {
    const { t, navigate } = this.props;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .setUpdateConfig(data)
          .then((response) => {
            const res = convertPropertiesToCamelCase(response.response);
            this.setState(
              {
                isLoading: false,
                updateSetting: res.updateSetting,
                updateSetClone: res.updateSetting,
              },
              () => {
                setTimeout(() => {
                  this.getOnlyUpdateStatus(); //update check
                }, 1000);
              }
            );
          })
          .catch((err) => {
            console.log(err);
            const o = err.data.response;
            if (o.error === '422-652') {
              this.setState({
                isUpdateError: true,
                isLoading: false,
                //errorCode: o.error,
                errorMsg: t('system.message.not_installed_update'),
              });
            } else if (o.error === '403-366') { //403-002
              this.setState({
                isUpdateError: true,
                isLoading: false,
                //errorCode: o.error,
                errorMsg: t('system.message.license_expired'),
              }, () => {
                window.setTimeout(() => {
                  navigate('/systems/license');
                }, 1500);
              });
            } else if (o.error === '403-001') {
              this.setState({
                isUpdateError: true,
                isLoading: false,
                //errorCode: o.error,
                errorMsg: t('system.message.not_registerd_company'),
              }, () => {
                window.setTimeout(() => {
                  navigate('/systems/license');
                }, 1500);
              });
            } else if (o.error === '422-651') {
              window.setTimeout(() => {
                navigate('/systems/license');
              }, 1500);
            }
          });
      }
    );
  }

  setProxyConfig() {
    const { updateProxy } = this.state;
    const { t } = this.props;

    if (updateProxy.proxy_mode === 'pac_url' || updateProxy.proxy_mode === 'manual') {
      if (updateProxy.proxy_url === '') {
        return this.setState({
          isProxyError: true,
          proxyErrorMsg: t('system.message.required_proxy'),
        });
      }
    }

    const data = {
      proxy_mode: updateProxy.proxy_mode,
      proxy_url: updateProxy.proxy_url,
    };
    this.setState(
      {
        isLoadingProxyElement: true,
      },
      () => {
        api
          .setProxyConfig(data)
          .then(() => {
            this.setState({
              isLoadingProxyElement: false,
            });
          })
          .catch((err) => {
            console.log(err);
            const o = err.data.response;
            if (o.error === '422-366') {
              this.setState({
                isProxyError: true,
                isLoadingProxyElement: false,
                proxyErrorMsg: o.error_description,
              });
            }
          });
      }
    );
  }

  runUpdate() {
    const { t, navigate } = this.props;
    api
      .runUpdate()
      .then((response) => {
        const data = response.response;
        if (data.start) {
          this.getOnlyUpdateStatus('run');
        }
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        if (o.error === '422-653') {
          console.log(o.error);
          this.setState({
            isLoadingBtn: false,
            isUpdateError: true,
            //errorCode: o.error,
            errorMsg: t('system.message.cannot_proceed_new_update'),
          });
        } else if (o.error === '422-652') {
          this.setState({
            isUpdateError: true,
            isLoadingBtn: false,
            //errorCode: o.error,
            errorMsg: t('system.message.not_installed_update'),
          });
        } else if (o.error === '403-366') {
          this.setState({
            isLoadingBtn: false,
            isUpdateError: true,
            //errorCode: o.error,
            errorMsg: t('system.message.license_expired'),
          }, () => {
            window.setTimeout(() => {
              navigate('/systems/license');
            }, 1500);
          });
        } else if (o.error === '403-001') {
          this.setState({
            isUpdateError: true,
            isLoadingBtn: false,
            //errorCode: o.error,
            errorMsg: t('system.message.not_registerd_company'),
          }, () => {
            window.setTimeout(() => {
              navigate('/systems/license');
            }, 1500);
          });
        } else if (o.error === '422-651') {
          window.setTimeout(() => {
            navigate('/systems/license');
          }, 1500);
        } else {
          this.setState({
            isLoadingBtn: false,
            isUpdateError: true,
            //errorCode: o.error || null,
            errorMsg: t('system.message.error_run_update'),
          });
        }
      });
  }

  stopUpdate() {
    const { t } = this.props;
    api
      .stopUpdate()
      .then((response) => {
        const data = response.response;
        if (data.stop) {
          this.getOnlyUpdateStatus('stop');
        }
      })
      .catch((err) => {
        console.log(err);
        //const o = err.data.response;

        this.setState({
          isLoadingBtn: false,
          isUpdateError: true,
          //errorCode: o.error || null,
          errorMsg: t('system.message.error_stop_update'),
        });
      });
  }

  showUpdateLog() {
    api
      .showUpdateLog()
      .then((response) => {
        const data = response.response;
        this.setState({
          updateLogs: data,
          isVisibleLog: true,
          isLoadingChk: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  renderLabel(obj) {
    const { t } = this.props;
    const style = {
      lineHeight: '10px',
      verticalAlign: 'middle',
      marginLeft: '8px',
    };
    if (obj.status === 'Invalid') {
      return (
        <Label color="red" size="tiny" style={style}>
          {t('system.list.invalid')}
        </Label>
      );
    } if (obj.status === 'Updating') {
      return (
        <img
          src={progress}
          role="presentation"
          style={{
            width: 15,
            height: 15,
            margin: '0 0 0 5px',
            verticalAlign: 'middle',
          }}
          alt=""
        />
      );
    } if (obj.status === 'Installed') {
      return (
        <Label color="green" size="tiny" style={style}>
          {t('system.list.installed')}
        </Label>
      );
    }
  }

  renderSelectValue(day) {
    const { updateSetting } = this.state;
    if (updateSetting.schedule.length !== 0) {
      const selectedData = updateSetting.schedule.filter((item) => {
        return item.day_of_week === day;
      });
      if (selectedData.length !== 0) {
        return selectedData[0].hour;
      }
      return '';
    }
    return '';
  }

  renderSelectMinute(day) {
    const { updateSetting } = this.state;
    if (updateSetting.schedule.length !== 0) {
      const selectedData = updateSetting.schedule.filter((item) => {
        return item.day_of_week === day;
      });
      if (selectedData.length !== 0) {
        return selectedData[0].minute;
      }
      return '';
    }
    return '';
  }

  render() {
    const {
      checkValue,
      isLoading,
      isUpdateError,
      errorMsg,
      latestUpdates,
      updateSetting,
      updateStatus,
      updateProxy,
      isVisibleLog,
      updateLogs,
      isLoadingBtn,
      isLoadingChk,
      isProxyError,
      proxyErrorMsg,
      isLoadingProxyElement,
      isLoadingProxyBtn,
    } = this.state;
    const { t } = this.props;

    const currentLocale = localStorage.getItem('i18nextLng');

    const renderIfReady = (element) => {
      return !isLoading ? (
        element
      ) : (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const renderIfReadyProxyElement = (element) => {
      return !isLoadingProxyElement ? (
        element
      ) : (
        <Loader size="medium" style={{ display: 'block', lineHeight: '25px' }}>
          {t('modal.message.loading')}
        </Loader>
      );
    };

    const checkHours = (string) => {
      return updateSetting.schedule.map((item) => {
        return item.day_of_week;
      }).indexOf(string);
    };

    // eslint-disable-next-line react/no-unstable-nested-components
    function BtnProgress() {
      return (
        <img
          src={progress}
          role="presentation"
          style={{
            width: 15,
            height: 15,
            margin: '0 0 0 5px',
            verticalAlign: 'middle',
          }}
          alt=""
        />
      );
    }

    return (
      <div>
        <div className="content">
          <div className="setting_small_box setting_small_box_2">
            <h2 className="page_title">
              {t('system.list.latest_updates')}
              {isUpdateError ? <span className="error">{errorMsg}</span> : null}
            </h2>
            {renderIfReady(
              <div>
                <div className="setting_contnets">
                  <div className="setting_contnet_wrap">
                    <h3 className="setting_content_title">{t('system.list.software_updates')}</h3>
                    <div className="setting_content">
                      <div className="text">
                        {latestUpdates.clarity && latestUpdates.clarity.show ? (
                          <div className="text_wrap">
                            {t('system.list.clarity_version')}
                            <span>{latestUpdates.clarity.version}</span>
                          </div>
                        ) : null}
                        {latestUpdates.clarity && latestUpdates.clarity.show ? this.renderLabel(latestUpdates.clarity) : null}
                      </div>
                    </div>
                  </div>
                  {
                    latestUpdates.oss_db && latestUpdates.security_db && (latestUpdates.oss_db.show || latestUpdates.security_db.show)
                    && (
                      <div className="setting_contnet_wrap">
                        <h3 className="setting_content_title">{t('system.list.database_updates')}</h3>
                        <div className="setting_content">
                          <div className="text">
                            {latestUpdates.oss_db && latestUpdates.oss_db.show ? (
                              <div className="text_wrap">
                                {t('system.list.oss_db')}
                                <span>{latestUpdates.oss_db.version}</span>
                              </div>
                            ) : null}
                            {latestUpdates.oss_db && latestUpdates.oss_db.show ? this.renderLabel(latestUpdates.oss_db) : null}
                          </div>
                        </div>
                        <div className="setting_content">
                          <div className="text">
                            {latestUpdates.security_db && latestUpdates.security_db.show ? (
                              <div className="text_wrap">
                                {t('system.list.security_db')}
                                <span>{latestUpdates.security_db.version}</span>
                              </div>
                            ) : null}
                            {latestUpdates.security_db && latestUpdates.security_db.show
                              ? this.renderLabel(latestUpdates.security_db)
                              : null}
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {updateStatus !== 'invalid' && (
                    <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                      <div className="setting_content">
                        <div className="right_box">
                          {!isLoadingBtn ? (
                            <a
                              className={cx('update', {
                                disable: updateStatus === 'updating',
                              })}
                              onClick={this.handleUpdateToggle}
                            >
                              {updateStatus === 'idle' && 'Update'}
                              {updateStatus === 'updating' && 'Stop'}
                            </a>
                          ) : (
                            <a>
                              <img
                                src={progress}
                                role="presentation"
                                style={{
                                  width: 35,
                                  height: 35,
                                  verticalAlign: 'middle',
                                }}
                                alt=""
                              />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <Message
                  icon
                  style={{ width: '845px' }}
                  className={cx({ hide: !isVisibleLog })}
                >
                  <Message.Content
                    className="msg_content"
                  >
                    <Message.Header>
                      {
                        isLoadingChk ? (
                          <img
                            src={progress}
                            role="presentation"
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '5px',
                              verticalAlign: 'middle',
                            }}
                            alt=""
                          />
                        ) : (
                          <Checkbox
                            toggle
                            checked={isVisibleLog}
                            label={updateStatus === 'updating' ? t('system.list.updating') : t('system.list.update_completed')}
                            onChange={this.handleLogToggle}
                          />
                        )
                      }
                      {
                        !isLoadingChk && updateStatus === 'updating' ? (
                          <img
                            src={progress}
                            role="presentation"
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '5px',
                              verticalAlign: 'middle',
                            }}
                            alt=""
                          />
                        ) : null
                      }
                    </Message.Header>
                    {
                      isVisibleLog && updateLogs.length !== 0 ? (
                        <div style={{ height: '150px' }}>
                          <table className="log_table">
                            <colgroup>
                              <col style={{ width: '7.5%' }} />
                              <col style={{ width: '20%' }} />
                              <col style={{ width: '7.5%' }} />
                              <col style={{ width: '30%' }} />
                              <col style={{ width: '35%' }} />
                            </colgroup>
                            <thead>
                              <tr>
                                <th>{t('system.list.action')}</th>
                                <th>{t('system.list.product')}</th>
                                <th>{t('system.list.progress')}</th>
                                <th>{t('system.list.result')}</th>
                                <th>{t('system.list.time')}</th>
                              </tr>
                            </thead>
                          </table>
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                            style={{ height: '88%' }}
                          >
                            <table className="log_table">
                              <colgroup>
                                <col style={{ width: '7.5%' }} />
                                <col style={{ width: '20%' }} />
                                <col style={{ width: '7.5%' }} />
                                <col style={{ width: '30%' }} />
                                <col style={{ width: '35%' }} />
                              </colgroup>
                              <tbody>
                                {
                                  updateLogs.map((item) => {
                                    return (
                                      <tr key={uuidv4()}>
                                        <td>{item.action}</td>
                                        <td>{item.product}</td>
                                        <td>
                                          {item.progress}
                                          %
                                        </td>
                                        <td>{item.result}</td>
                                        <td>{item.time}</td>
                                      </tr>
                                    );
                                  })
                                }
                              </tbody>
                            </table>
                          </Scrollbars>
                        </div>
                      ) : null
                    }
                  </Message.Content>
                </Message>
                <div className="line" />

                <h2 className="page_title">{t('system.list.update_settings')}</h2>
                <div className="setting_contnets" style={{ marginBottom: '35px' }}>
                  <div className="setting_contnet_wrap">
                    <div className="custom_content">
                      <h3 className="setting_content_title">{t('system.list.when_to_update')}</h3>
                      <div className="setting_content">
                        <div className="small_box_3">
                          <div className="switch">
                            <a
                              className={cx({ checked: updateSetting.mode === 'never' })}
                              onClick={this.handleStyleChange}
                            >
                              {t('system.list.never')}
                            </a>
                            <a
                              className={cx({ checked: updateSetting.mode === 'interval' })}
                              onClick={this.handleStyleChange}
                            >
                              {t('system.list.interval')}
                            </a>
                            <a
                              className={cx({ checked: updateSetting.mode === 'schedule' })}
                              onClick={this.handleStyleChange}
                            >
                              {t('system.list.scheduled')}
                            </a>
                          </div>
                        </div>
                        {
                          updateSetting.mode === 'interval'
                          && (
                            <table
                              className={cx('table table_type_2', {
                                disabled: updateSetting.mode !== 'schedule',
                              })}
                              style={{ width: '50%' }}
                            >
                              <colgroup>
                                <col style={{ width: '40%' }} />
                                <col style={{ width: '60%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td>
                                    <div className="label_wrap">
                                      <label>
                                        {t('system.list.update_interval')}
                                      </label>
                                    </div>
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      value={updateSetting.interval}
                                      onChange={this.handleTimeChange}
                                      min="1"
                                      max="168"
                                      data-id="interval"
                                      placeholder={t('system.list.update_interval_placeholder')}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          )
                        }
                        {
                          updateSetting.mode === 'schedule'
                          && (
                            <table
                              className={cx('table table_type_2', {
                                disabled: updateSetting.mode !== 'schedule',
                              })}
                              style={{ width: '50%' }}
                            >
                              <colgroup>
                                <col style={{ width: '40%' }} />
                                <col style={{ width: '60%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td>
                                    <Checkbox
                                      label={t('system.list.mon')}
                                      value="mon"
                                      checked={checkValue.indexOf('mon') > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  </td>
                                  <td>
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('mon') === -1
                                          }
                                          value={this.renderSelectValue('mon')}
                                          onChange={this.handleTimeChange}
                                          data-id="mon"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {t('system.list.am')}
                                                {i < 10 ? '0'.concat(i) : i}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {t('system.list.pm')}
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      ) : (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('mon') === -1
                                          }
                                          value={this.renderSelectValue('mon')}
                                          onChange={this.handleTimeChange}
                                          data-id="mon"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {i < 10 ? '0'.concat(i) : i}
                                                {' '}
                                                {t('system.list.am')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {' '}
                                                {t('system.list.pm')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      )
                                    }
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={checkHours('mon') === -1}
                                          value={this.renderSelectMinute('mon')}
                                          onChange={this.handleMinChange}
                                          data-id="mon"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>{`0${t('system.list.min')}`}</option>
                                          <option value={15}>{`15${t('system.list.min')}`}</option>
                                          <option value={30}>{`30${t('system.list.min')}`}</option>
                                          <option value={45}>{`45${t('system.list.min')}`}</option>
                                        </select>
                                      ) : (
                                        <select
                                          disabled={checkHours('mon') === -1}
                                          value={this.renderSelectMinute('mon')}
                                          onChange={this.handleMinChange}
                                          data-id="mon"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>0</option>
                                          <option value={15}>15</option>
                                          <option value={30}>30</option>
                                          <option value={45}>45</option>
                                        </select>
                                      )
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <Checkbox
                                      label={t('system.list.tue')}
                                      value="tue"
                                      checked={checkValue.indexOf('tue') > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  </td>
                                  <td>
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('tue') === -1
                                          }
                                          value={this.renderSelectValue('tue')}
                                          onChange={this.handleTimeChange}
                                          data-id="tue"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {t('system.list.am')}
                                                {i < 10 ? '0'.concat(i) : i}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {t('system.list.pm')}
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      ) : (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('tue') === -1
                                          }
                                          value={this.renderSelectValue('tue')}
                                          onChange={this.handleTimeChange}
                                          data-id="tue"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {i < 10 ? '0'.concat(i) : i}
                                                {' '}
                                                {t('system.list.am')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {' '}
                                                {t('system.list.pm')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      )
                                    }
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={checkHours('tue') === -1}
                                          value={this.renderSelectMinute('tue')}
                                          onChange={this.handleMinChange}
                                          data-id="tue"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>{`0${t('system.list.min')}`}</option>
                                          <option value={15}>{`15${t('system.list.min')}`}</option>
                                          <option value={30}>{`30${t('system.list.min')}`}</option>
                                          <option value={45}>{`45${t('system.list.min')}`}</option>
                                        </select>
                                      ) : (
                                        <select
                                          disabled={checkHours('tue') === -1}
                                          value={this.renderSelectMinute('tue')}
                                          onChange={this.handleMinChange}
                                          data-id="tue"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>0</option>
                                          <option value={15}>15</option>
                                          <option value={30}>30</option>
                                          <option value={45}>45</option>
                                        </select>
                                      )
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <Checkbox
                                      label={t('system.list.wed')}
                                      value="wed"
                                      checked={checkValue.indexOf('wed') > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  </td>
                                  <td>
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('wed') === -1
                                          }
                                          value={this.renderSelectValue('wed')}
                                          onChange={this.handleTimeChange}
                                          data-id="wed"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {t('system.list.am')}
                                                {i < 10 ? '0'.concat(i) : i}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {t('system.list.pm')}
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      ) : (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('wed') === -1
                                          }
                                          value={this.renderSelectValue('wed')}
                                          onChange={this.handleTimeChange}
                                          data-id="wed"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {i < 10 ? '0'.concat(i) : i}
                                                {' '}
                                                {t('system.list.am')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {' '}
                                                {t('system.list.pm')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      )
                                    }
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={checkHours('wed') === -1}
                                          value={this.renderSelectMinute('wed')}
                                          onChange={this.handleMinChange}
                                          data-id="wed"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>{`0${t('system.list.min')}`}</option>
                                          <option value={15}>{`15${t('system.list.min')}`}</option>
                                          <option value={30}>{`30${t('system.list.min')}`}</option>
                                          <option value={45}>{`45${t('system.list.min')}`}</option>
                                        </select>
                                      ) : (
                                        <select
                                          disabled={checkHours('wed') === -1}
                                          value={this.renderSelectMinute('wed')}
                                          onChange={this.handleMinChange}
                                          data-id="wed"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>0</option>
                                          <option value={15}>15</option>
                                          <option value={30}>30</option>
                                          <option value={45}>45</option>
                                        </select>
                                      )
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <Checkbox
                                      label={t('system.list.thu')}
                                      value="thu"
                                      checked={checkValue.indexOf('thu') > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  </td>
                                  <td>
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('thu') === -1
                                          }
                                          value={this.renderSelectValue('thu')}
                                          onChange={this.handleTimeChange}
                                          data-id="thu"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {t('system.list.am')}
                                                {i < 10 ? '0'.concat(i) : i}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {t('system.list.pm')}
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      ) : (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('thu') === -1
                                          }
                                          value={this.renderSelectValue('thu')}
                                          onChange={this.handleTimeChange}
                                          data-id="thu"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {i < 10 ? '0'.concat(i) : i}
                                                {' '}
                                                {t('system.list.am')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {' '}
                                                {t('system.list.pm')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      )
                                    }
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={checkHours('thu') === -1}
                                          value={this.renderSelectMinute('thu')}
                                          onChange={this.handleMinChange}
                                          data-id="thu"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>{`0${t('system.list.min')}`}</option>
                                          <option value={15}>{`15${t('system.list.min')}`}</option>
                                          <option value={30}>{`30${t('system.list.min')}`}</option>
                                          <option value={45}>{`45${t('system.list.min')}`}</option>
                                        </select>
                                      ) : (
                                        <select
                                          disabled={checkHours('thu') === -1}
                                          value={this.renderSelectMinute('thu')}
                                          onChange={this.handleMinChange}
                                          data-id="thu"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>0</option>
                                          <option value={15}>15</option>
                                          <option value={30}>30</option>
                                          <option value={45}>45</option>
                                        </select>
                                      )
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <Checkbox
                                      label={t('system.list.fri')}
                                      value="fri"
                                      checked={checkValue.indexOf('fri') > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  </td>
                                  <td>
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('fri') === -1
                                          }
                                          value={this.renderSelectValue('fri')}
                                          onChange={this.handleTimeChange}
                                          data-id="fri"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {t('system.list.am')}
                                                {i < 10 ? '0'.concat(i) : i}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {t('system.list.pm')}
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      ) : (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('fri') === -1
                                          }
                                          value={this.renderSelectValue('fri')}
                                          onChange={this.handleTimeChange}
                                          data-id="fri"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {i < 10 ? '0'.concat(i) : i}
                                                {' '}
                                                {t('system.list.am')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {' '}
                                                {t('system.list.pm')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      )
                                    }
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={checkHours('fri') === -1}
                                          value={this.renderSelectMinute('fri')}
                                          onChange={this.handleMinChange}
                                          data-id="fri"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>{`0${t('system.list.min')}`}</option>
                                          <option value={15}>{`15${t('system.list.min')}`}</option>
                                          <option value={30}>{`30${t('system.list.min')}`}</option>
                                          <option value={45}>{`45${t('system.list.min')}`}</option>
                                        </select>
                                      ) : (
                                        <select
                                          disabled={checkHours('fri') === -1}
                                          value={this.renderSelectMinute('fri')}
                                          onChange={this.handleMinChange}
                                          data-id="fri"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>0</option>
                                          <option value={15}>15</option>
                                          <option value={30}>30</option>
                                          <option value={45}>45</option>
                                        </select>
                                      )
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <Checkbox
                                      label={t('system.list.sat')}
                                      value="sat"
                                      checked={checkValue.indexOf('sat') > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  </td>
                                  <td>
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('sat') === -1
                                          }
                                          value={this.renderSelectValue('sat')}
                                          onChange={this.handleTimeChange}
                                          data-id="sat"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {t('system.list.am')}
                                                {i < 10 ? '0'.concat(i) : i}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {t('system.list.pm')}
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      ) : (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('sat') === -1
                                          }
                                          value={this.renderSelectValue('sat')}
                                          onChange={this.handleTimeChange}
                                          data-id="sat"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {i < 10 ? '0'.concat(i) : i}
                                                {' '}
                                                {t('system.list.am')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {' '}
                                                {t('system.list.pm')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      )
                                    }
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={checkHours('sat') === -1}
                                          value={this.renderSelectMinute('sat')}
                                          onChange={this.handleMinChange}
                                          data-id="sat"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>{`0${t('system.list.min')}`}</option>
                                          <option value={15}>{`15${t('system.list.min')}`}</option>
                                          <option value={30}>{`30${t('system.list.min')}`}</option>
                                          <option value={45}>{`45${t('system.list.min')}`}</option>
                                        </select>
                                      ) : (
                                        <select
                                          disabled={checkHours('sat') === -1}
                                          value={this.renderSelectMinute('sat')}
                                          onChange={this.handleMinChange}
                                          data-id="sat"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>0</option>
                                          <option value={15}>15</option>
                                          <option value={30}>30</option>
                                          <option value={45}>45</option>
                                        </select>
                                      )
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <Checkbox
                                      label={t('system.list.sun')}
                                      value="sun"
                                      checked={checkValue.indexOf('sun') > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  </td>
                                  <td>
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('sun') === -1
                                          }
                                          value={this.renderSelectValue('sun')}
                                          onChange={this.handleTimeChange}
                                          data-id="sun"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {t('system.list.am')}
                                                {i < 10 ? '0'.concat(i) : i}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {t('system.list.pm')}
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {t('system.list.hour')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      ) : (
                                        <select
                                          disabled={
                                            updateSetting.mode !== 'schedule'
                                        || checkValue.indexOf('sun') === -1
                                          }
                                          value={this.renderSelectValue('sun')}
                                          onChange={this.handleTimeChange}
                                          data-id="sun"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_hour')}
                                          </option>
                                          {[...Array(13)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={i}>
                                                {i < 10 ? '0'.concat(i) : i}
                                                {' '}
                                                {t('system.list.am')}
                                              </option>
                                            );
                                          })}
                                          {[...Array(11)].map((x, i) => {
                                            return (
                                              <option key={uuidv4()} value={(i + 13) % 24}>
                                                {i + 1 < 10 ? '0'.concat(i + 1) : i + 1}
                                                {' '}
                                                {t('system.list.pm')}
                                              </option>
                                            );
                                          })}
                                        </select>
                                      )
                                    }
                                    {
                                      currentLocale === 'kr' || currentLocale === 'ja' ? (
                                        <select
                                          disabled={checkHours('sun') === -1}
                                          value={this.renderSelectMinute('sun')}
                                          onChange={this.handleMinChange}
                                          data-id="sun"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>{`0${t('system.list.min')}`}</option>
                                          <option value={15}>{`15${t('system.list.min')}`}</option>
                                          <option value={30}>{`30${t('system.list.min')}`}</option>
                                          <option value={45}>{`45${t('system.list.min')}`}</option>
                                        </select>
                                      ) : (
                                        <select
                                          disabled={checkHours('sun') === -1}
                                          value={this.renderSelectMinute('sun')}
                                          onChange={this.handleMinChange}
                                          data-id="sun"
                                        >
                                          <option value="" disabled>
                                            {t('system.list.select_min')}
                                          </option>
                                          <option value={0}>0</option>
                                          <option value={15}>15</option>
                                          <option value={30}>30</option>
                                          <option value={45}>45</option>
                                        </select>
                                      )
                                    }
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                    <div className="setting_content">
                      <div className="right_box">
                        <a
                          className="update"
                          onClick={this.onSubmit}
                        >
                          {t('modal.button.save')}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                {updateProxy.proxy_mode !== 'invalid' ? <div className="line" /> : null}
                <div style={{ position: 'relative' }}>
                  {renderIfReadyProxyElement(
                    <div>
                      {
                        updateProxy.proxy_mode !== 'invalid' ? (
                          <div className="setting_contnets" style={{ marginBottom: '35px' }}>
                            <div className="setting_contnet_wrap">
                              <div className="custom_content">
                                <h3 className="setting_content_title">
                                  {t('system.list.use_proxy')}
                                  {isProxyError ? <span className="error" style={{ display: 'contents', margin: '0 0 0 5px' }}>{proxyErrorMsg}</span> : null}
                                </h3>
                                <div className="setting_content">
                                  {/**never, system_config, pac_url, manual */}
                                  <div className="small_box_4">
                                    <div className="switch">
                                      <a
                                        className={cx({ checked: updateProxy.proxy_mode === 'never' })}
                                        onClick={() => {
                                          return this.handleProxyChange('never');
                                        }}
                                      >
                                        {isLoadingProxyBtn && updateProxy.proxy_mode === 'never' ? BtnProgress() : t('system.list.disabled')}
                                      </a>
                                      <a
                                        className={cx({ checked: updateProxy.proxy_mode === 'system_config' })}
                                        onClick={() => {
                                          return this.handleProxyChange('system_config');
                                        }}
                                      >
                                        {isLoadingProxyBtn && updateProxy.proxy_mode === 'system_config' ? BtnProgress() : t('system.list.system_config')}
                                      </a>
                                      <a
                                        className={cx({ checked: updateProxy.proxy_mode === 'pac_url' })}
                                        onClick={() => {
                                          return this.handleProxyChange('pac_url');
                                        }}
                                      >
                                        {isLoadingProxyBtn && updateProxy.proxy_mode === 'pac_url' ? BtnProgress() : t('system.list.pac_url')}
                                      </a>
                                      <a
                                        className={cx({ checked: updateProxy.proxy_mode === 'manual' })}
                                        onClick={() => {
                                          return this.handleProxyChange('manual');
                                        }}
                                      >
                                        {isLoadingProxyBtn && updateProxy.proxy_mode === 'manual' ? BtnProgress() : t('system.list.manual')}
                                      </a>
                                    </div>
                                  </div>
                                  <table className="table table_type_2">
                                    <tbody>
                                      {
                                        updateProxy.proxy_mode === 'never' && !isLoadingProxyBtn
                                        && (
                                          <tr>
                                            <td>
                                              <div className="setting_contnet_wrap" style={{ paddingLeft: '1.85714em', height: '96px' }}>
                                                <div className="" style={{ fontSize: '12px', color: '#b7b7b7' }}>{t('system.list.no_proxy')}</div>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      }
                                      {
                                        updateProxy.proxy_mode === 'system_config' && !isLoadingProxyBtn
                                        && (
                                          <tr>
                                            <td>
                                              <div className="setting_contnet_wrap" style={{ paddingLeft: '1.85714em', height: '96px' }}>
                                                <div className="" style={{ fontSize: '12px', color: '#b7b7b7' }}>{t('system.list.use_system_proxy')}</div>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      }
                                      {
                                        updateProxy.proxy_mode === 'pac_url' && !isLoadingProxyBtn
                                        && (
                                          <tr>
                                            <td>
                                              <div className="setting_contnet_wrap" style={{ paddingLeft: '1.85714em' }}>
                                                <div className="" style={{ fontSize: '14px', fontWeight: '500' }}>{t('system.list.proxy_pac_url')}</div>
                                                <div className="" style={{ marginTop: '5px' }}>
                                                  <div style={{ color: '#b7b7b7', fontSize: '12px' }}>{t('system.list.auto_detect_settings')}</div>
                                                  <div className="setting_content">
                                                    <input
                                                      type="text"
                                                      style={{ width: '50%' }}
                                                      value={updateProxy.proxy_url}
                                                      onChange={this.handleInputChange}
                                                      placeholder={t('system.list.proxy_pac_url_placeholder')}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      }
                                      {
                                        updateProxy.proxy_mode === 'manual' && !isLoadingProxyBtn
                                        && (
                                          <tr>
                                            <td>
                                              <div className="setting_contnet_wrap" style={{ paddingLeft: '1.85714em' }}>
                                                <div className="" style={{ fontSize: '14px', fontWeight: '500' }}>{t('system.list.proxy_manual')}</div>
                                                <div className="" style={{ marginTop: '5px' }}>
                                                  <div style={{ color: '#b7b7b7', fontSize: '12px' }}>{t('system.list.manual_proxy_config')}</div>
                                                  <div className="setting_content">
                                                    <input
                                                      type="text"
                                                      style={{ width: '50%' }}
                                                      value={updateProxy.proxy_url}
                                                      onChange={this.handleInputChange}
                                                      placeholder={t('system.list.proxy_manual_placeholder')}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      }
                                      {
                                        isLoadingProxyBtn
                                        && (
                                          <tr>
                                            <td>
                                              <div className="setting_contnet_wrap" style={{ paddingLeft: '1.85714em', height: '96px' }} />
                                            </td>
                                          </tr>
                                        )
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div className="setting_contnet_wrap" style={{ marginTop: '0' }}>
                              <div className="setting_content">
                                <div className="right_box">
                                  <a
                                    className="update"
                                    onClick={this.setProxyConfig}
                                  >
                                    {t('modal.button.save')}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null
                      }
                    </div>
                  )}
                </div>
                {/***
                <div className="setting_bottom">
                  <a onClick={this.onSubmit} className="save">
                    Save
                  </a>
                </div>
                 */}
              </div>
            )}
          </div>
        </div>
        <Modal open={this.state.modalAlert} onClose={this.handleCloseAlert}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.state.modalAlertTitle}</h2>
                <p className="text">{this.state.modalAlertMsg}</p>
                <div className="button_wrap">
                  <a onClick={this.handleCloseAlert} className="center_button">
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(UpdateSystem))));
